import React from "react"
import SEO from "../components/common/SEO"
import ServicePageHero from "../components/services/ServicePageHero.jsx"
const facialTreatments = [
  {
    id: 1,
    title: "Soin de Visage Classique",
    price: "120 DT",
    description:
      "Un soin complet adapté à tous les types de peau pour nettoyer, hydrater et revitaliser le visage.",
  },

  {
    id: 2,
    title: "Soin Détox Purifiant",
    price: "140 DT",
    description:
      "Soin purifiant spécialement conçu pour les peaux mixtes à grasses afin d'éliminer les impuretés.",
  },

  {
    id: 3,
    title: "Soin Hydratant",
    price: "140 DT",
    description:
      "Traitement intensif qui nourrit et hydrate la peau en profondeur pour un teint éclatant.",
  },

  {
    id: 4,
    title: "Soin Anti-Âge",
    price: "180 DT",
    description:
      "Soin premium visant à améliorer la fermeté, l'élasticité et l'éclat naturel de la peau.",
  },

  {
    id: 5,
    title: "Soin Éclat",
    price: "100 DT",
    description:
      "Soin rapide pour redonner luminosité et fraîcheur au visage avant un événement ou une occasion spéciale.",
  },

  {
    id: 6,
    title: "Soin Peaux Sensibles",
    price: "140 DT",
    description:
      "Traitement doux spécialement conçu pour calmer, protéger et rééquilibrer les peaux sensibles.",
  },

  {
    id: 7,
    title: "Pose Masque",
    price: "50 DT",
    description:
      "Application d'un masque adapté à votre type de peau pour hydrater, purifier ou apaiser.",
  },

  {
    id: 8,
    title: "Modelage Détente Visage",
    price: "50 DT",
    description:
      "Massage relaxant du visage favorisant la détente musculaire et l'éclat du teint.",
  },
]

export default function FacialServices() {
  return (
    <>
      <SEO
        title="Soins du Visage | Centre SpaLand Saphir Palace & Spa"
        description="Découvrez nos soins du visage hydratants, anti-âge, purifiants et éclat pour tous les types de peau."
        keywords="soin visage hammamet, soin anti age, soin hydratant, spa hammamet"
        url="https://www.yourdomain.com/services/soins-visage"
      />

      <main>
        {/* Hero */}
      {/*
      <section
          style={{
            padding: "120px 20px",
            textAlign: "center",
            background: "#f9f6f1",
          }}
        >
          <h1
            style={{
              fontSize: "3rem",
              marginBottom: "20px",
            }}
          >
            Soins du Visage
          </h1>

          <p
            style={{
              maxWidth: "700px",
              margin: "0 auto",
              color: "#666",
              lineHeight: "1.8",
            }}
          >
            Offrez à votre peau l'attention qu'elle mérite grâce à nos soins
            experts conçus pour hydrater, purifier, apaiser et révéler son
            éclat naturel.
          </p>
        </section>
*/}
<ServicePageHero
  title="Soins du Visage"
  description="Des soins experts adaptés à chaque type de peau pour hydrater, purifier et révéler l'éclat naturel du visage."
  image="/images/service-facial.jpg"
/>
        {/* Treatments */}
        <section
          style={{
            padding: "80px 20px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(320px, 1fr))",
              gap: "30px",
            }}
          >
            {facialTreatments.map((treatment) => (
              <div
                key={treatment.id}
                style={{
                  background: "#fff",
                  borderRadius: "20px",
                  padding: "30px",
                  boxShadow:
                    "0 10px 30px rgba(0,0,0,0.08)",
                }}
              >
                <h3
                  style={{
                    marginBottom: "15px",
                  }}
                >
                  {treatment.title}
                </h3>

                <div
                  style={{
                    marginBottom: "15px",
                    fontWeight: "600",
                    color: "#b8955d",
                  }}
                >
                  {treatment.price}
                </div>

                <p
                  style={{
                    color: "#666",
                    lineHeight: "1.8",
                    marginBottom: "20px",
                  }}
                >
                  {treatment.description}
                </p>

                <a
                  href="https://wa.me/21697902051"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-block",
                    background: "#b8955d",
                    color: "#fff",
                    padding: "12px 24px",
                    borderRadius: "50px",
                    textDecoration: "none",
                    fontWeight: "600",
                  }}
                >
                  Réserver via WhatsApp
                </a>
              </div>
            ))}
          </div>
        </section>
      </main>
    </>
  )
}